module.exports = __webpack_public_path__ + "static/media/nc.eaa43350.svg";